import { render, staticRenderFns } from "./social-list_pc.vue?vue&type=template&id=eb2bda2c&scoped=true&"
import script from "./social-list_pc.vue?vue&type=script&lang=js&"
export * from "./social-list_pc.vue?vue&type=script&lang=js&"
import style0 from "./social-list_pc.vue?vue&type=style&index=0&id=eb2bda2c&lang=less&scoped=true&"
import style1 from "./social-list_pc.vue?vue&type=style&index=1&id=eb2bda2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2bda2c",
  null
  
)

export default component.exports